import { ContentStoreKeywordsService } from 'src/services/Keywords';

export const createKeyword = async (
    { accessToken, keyword }: App.Keyword.CreateMutationVariables,
): Promise<Models.ContentStoreApi.V3.Keyword> => ContentStoreKeywordsService.createKeyword(
    accessToken,
    keyword,
);
